import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
  selector: 'lin-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  standalone: false,
})
export class ConfirmationComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) {}
}
